import {
  dateSortingAtom,
  dateValueAtom,
  dropOffDateAtom,
  orderIdSearchAtom,
  // isExpeditedAtom,
  orderStatusAtom,
  phoneSearchAtom,
  pickUpDateAtom,
  searchQueryAtom,
} from "atoms";
import { useSetAtom } from "jotai";

import { useFilterQueryParams } from "./index";

export const useResetFilters = () => {
  const { updateFilterParam } = useFilterQueryParams();

  const setSearchQuery = useSetAtom(searchQueryAtom);
  const setPhoneSearch = useSetAtom(phoneSearchAtom);
  const setOrderIdSearch = useSetAtom(orderIdSearchAtom);
  const setDateSorting = useSetAtom(dateSortingAtom);
  const setOrderStatus = useSetAtom(orderStatusAtom);
  const setPickUpDate = useSetAtom(pickUpDateAtom);
  const setDropOffDate = useSetAtom(dropOffDateAtom);
  // const setIsExpedited = useSetAtom(isExpeditedAtom);
  const setDateValue = useSetAtom(dateValueAtom);

  const resetFilters = () => {
    updateFilterParam("page", 1);
    updateFilterParam("pageSize", 10);
    setSearchQuery("");
    setPhoneSearch("");
    setOrderIdSearch(0);
    setOrderStatus(0);
    // setIsExpedited(null);
    setDateValue(undefined);
    setDateSorting(true);
    setPickUpDate(null);
    setDropOffDate(null);
  };

  return resetFilters;
};
